import React from 'react';
import {Input, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {I18n} from '../../I18n/components/companyMarket';
import AttributesList from '../AttributesList/AttributesList';

const ViewAttributesModal = (props) => {
	return (
		<Modal className="view-attributes-modal" isOpen={props.packageModal} toggle={props.packageModalToggle(null)}>
			<ModalHeader toggle={props.packageModalToggle(null)}>{I18n[props.lang].pack}</ModalHeader>
			<ModalBody>
				<label className="pockets-search__label" htmlFor="pockets-search">{I18n[props.lang].namePlaceholder}: </label>
				<Input
					type="text"
					name="pockets-search"
					id="pockets-search"
					className={props.isPackageNameExist ? "pocket-seacrch__input pocket-seacrch__input_error" : "pocket-seacrch__input"}
					placeholder={I18n[props.lang].namePlaceholder}
					onChange={event => {props.onChangePackageName(event)}}
					value={props.currentPackageName}
				/>
				{
					props.selectedPackage && props.selectedPackage.attributes && props.selectedPackage.attributes.length ? (
						<div>
							<h6>{I18n[props.lang].packAttributes}:</h6>
							<AttributesList
								attributes={props.selectedPackage.attributes ? props.selectedPackage.attributes : []}
								isAttributesChangingAllowed={true}
								updateAttributesList={props.updatePocketAttributesList}
								authority={props.authority}
								toggleApkModal={props.attributesPackageModalToggle}
								editDisable={props.isPackageNameExist}
								closeModal={props.packageModalToggle(null)}
							/>
						</div>
					) : ""
				}
			</ModalBody>
		</Modal>
	)
};

export default ViewAttributesModal;



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/ViewAttributesModal.js